module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "activity-product-card"
  }, [_c('v-flex', {
    staticClass: "product-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "product-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + (_vm.object ? _vm.object.avatar.url : '') + ')',
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "product-actions",
    attrs: {
      "xs12": "",
      "relative": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    },
    on: {
      "click": function($event) {
        _vm.choosePage('/' + _vm.object ? _vm.object.slug : '')
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48a58e09","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activityusercard.vue
// module id = 1710
// module chunks = 180